import React, { useState, useEffect, useRef, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { MdAlternateEmail } from "react-icons/md";
import { MdPermContactCalendar } from "react-icons/md";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { MdLocalHospital } from "react-icons/md";
import Switch from "react-switch";
import { IoIosCall } from "react-icons/io";
import EventChatInfo from "./EventChatInfo";
import "./GuideInfo.css";
import GrantModal from "../modal/grantModal/grantModal";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Modal from "../modal/Modal";
import NetworkLoader from "../NetworkLoader";
import { debounce, filter } from "lodash";
import { TbBuildingEstate } from "react-icons/tb";
import { PiCityFill } from "react-icons/pi";
import dayjs from "dayjs";

const allowedCountries = ["NG", "KE", "ET"];

const customerSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phone: yup.string().required("Phone number is required"),
  hospital: yup.string().required("Hospitals is required"),
  country: yup.string().required("Country is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  checked: yup.boolean(),
});

const newCustomerSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("invalid email").required("Email is required"),
  phone: yup.string().required("Phone number is required"),
  hospital: yup.string().required("Hospitals is required"),
  country: yup.string().required("Country is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  date: yup.string().required("Date is required"),
  time: yup.string().required("Time is required"),
  mode: yup.string().required("Mode is required"),
  supplies: yup.string().required("Supplies is required"),
  frequency: yup.string().required("Frequency is required"),
  amounts: yup.string().required("Amounts is required"),
  value: yup.string().required("Value is required"),
  feedback: yup.string().required("Feedback is required"),
  checked: yup.boolean(),
});

const EventInfo = () => {
  const ModalRef = useRef();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qValue = queryParams.get("q");

  const readUrl = `https://one.lifebank.ng/api/v1/marketing/reservation/event/${qValue}`;

  const appointmentUrl = `https://one.lifebank.ng/api/v1/marketing/reservation/event/${qValue}`;

  // const readUrl = `https://one.lifebanktest.com/v1/marketing/reservation/event/${qValue}`;

  // const appointmentUrl = `https://one.lifebanktest.com/v1/marketing/reservation/event/${qValue}`;

  const [isOpen, setIsOpen] = useState(false);

  const [activeStep, setActiveStep] = useState(0);
  const [chatEnabled, setChatEnabled] = useState(false);
  const [databaseValidator, setDatabaseValidator] = useState(false);

  const validationSchema = [customerSchema, newCustomerSchema];
  const currentValidationSchema = validationSchema[activeStep];

  const [isLoading, setIsLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");

  // Fetch states on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `https://countriesnow.space/api/v0.1/countries/`
        );
        const filteredCountries = response.data.data.filter((country) =>
          allowedCountries.includes(country.iso2)
        );
        setCountries(filteredCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // Fetch states when a country is selected
  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountry) return;
      try {
        const response = await axios.post(
          `https://countriesnow.space/api/v0.1/countries/states`,
          {
            country: selectedCountry,
          }
        );
        setStates(response.data.data.states);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, [selectedCountry]);

  // Fetch cities when a state is selected
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedState) return;
      try {
        const response = await axios.post(
          `https://countriesnow.space/api/v0.1/countries/state/cities`,
          {
            country: selectedCountry,
            state: selectedState,
          }
        );
        setCities(response.data.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, [selectedState]);

  const verifyCustomer = useCallback(
    async function (params) {
      const { email, phone } = params;
      console.log(phone);
      try {
        setIsLoading(true);
        const response = await axios.post(
          `https://one.lifebank.ng/api/v1/marketing/quick/check/guide`,
          {
            email: email,
            phone: phone,
          }
        );
        // const response = await axios.post(
        //   `https://one.lifebanktest.com/v1/marketing/quick/check/guide`,
        //   {
        //     email: email,
        //     phone: phone,
        //   }
        // );
        console.log("response", response);
        const itExists = response.data.data;
        if (itExists) {
          setDatabaseValidator(itExists);
          return itExists;
        }
        if (!chatEnabled && !itExists) ModalRef.current.openModal();
      } catch (error) {
        console.error("Error in verifying email:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [chatEnabled]
  );
  const {
    control,
    register,
    handleSubmit: registerForm,
    formState: { errors },
    trigger,
    watch,
    reset,
    setError,
  } = useForm({
    mode: "onchange",
    resolver: yupResolver(currentValidationSchema),
  });

  const watchEmail = watch("email");
  const watchPhone = watch("phone");

  // useEffect(() => {
  //   if (watchPhone === undefined || watchEmail === undefined) return;
  //   let phoneNumber = "";
  //   let countryCode = "";
  //   const phoneObj = parsePhoneNumber(watchPhone);
  //   if (phoneObj && phoneObj.countryCallingCode) {
  //     const { countryCallingCode, nationalNumber } = phoneObj;
  //     phoneNumber = nationalNumber;
  //     countryCode = `+${countryCallingCode}`;
  //   }

  //   const debounced = debounce(async () => {
  //     setIsLoading(true); // Set isLoading to true when debounce starts
  //     if (watchEmail && watchPhone) {
  //       const isValidPhoneNumber = validatePhoneNumber(
  //         phoneNumber,
  //         countryCode
  //       );
  //       if (isValidPhoneNumber) {
  //         setError("phone", {
  //           type: "server",
  //           message: "",
  //         });
  //         await verifyCustomer({ email: watchEmail, phone: phoneNumber });
  //       } else {
  //         setError("phone", {
  //           type: "server",
  //           message: "Invalid phone number",
  //         });
  //         setDatabaseValidator(false);
  //       }
  //     }
  //     setIsLoading(false); // Set isLoading to false after debounce is completed
  //   }, 2000);
  //   debounced();
  //   console.log(!!debounced);
  //   return () => {
  //     debounced.cancel();
  //   };
  // }, [watchEmail, watchPhone]);

  const validatePhoneNumber = (phoneNumber, countryCallingCode) => {
    console.log(phoneNumber, countryCallingCode);
    if (countryCallingCode === "+251" && phoneNumber.length === 12) {
      return true;
    } else if (countryCallingCode === "+234" && phoneNumber.length === 10) {
      return true;
    } else if (countryCallingCode === "+254" && phoneNumber.length === 9) {
      return true;
    } else {
      return false;
    }
  };

  const handleNextValidation = async () => {
    if (chatEnabled === true) {
      const isCurrentFormValid = await trigger();
      console.log(isCurrentFormValid);
      if (isCurrentFormValid) {
        setActiveStep((currentStep) => currentStep + 1);
      }
    }
  };
  console.log(!databaseValidator && chatEnabled);
  useEffect(() => {
    handleNextValidation();
  }, [chatEnabled]);

  const onSubmit = async (data) => {
    const phoneObj = parsePhoneNumber(data.phone);
    if (phoneObj && phoneObj.countryCallingCode) {
      const { countryCallingCode, nationalNumber } = phoneObj;
      data.countrycode = `+${countryCallingCode}`;
      data.phone = nationalNumber;
    }

    if (data.phone) {
      const isValidPhoneNumber = validatePhoneNumber(
        data.phone,
        data.countrycode
      );
      if (isValidPhoneNumber) {
        setError("phone", {
          type: "server",
          message: "",
        });
      } else {
        setError("phone", {
          type: "server",
          message: "Invalid phone number",
        });
        return;
      }
    }
    const withId = {
      ...data,
      q: qValue,
    };

    const payload = {
      ...withId,
      date: dayjs(data.date).format("YYYY-MM-DD"),
    };

    if (!chatEnabled) {
      await verifyCustomer({ email: data.email, phone: data.phone }).then(
        async (response) => {
          if (response) {
            const response = await axios.post(readUrl, withId);
            console.log(response);
            if (response.data.status !== "success") {
              setIsOpen(false);
              return notified();
            } else {
              setIsOpen(true);
            }
            reset();
            setDatabaseValidator(false);
          }
        }
      );
      return;
    }

    setIsLoading(true);
    try {
      if (chatEnabled) {
        const res = await axios.post(appointmentUrl, payload);
        console.log(res);
        if (res.data.status !== "success") {
          setIsOpen(false);
          return notified();
        } else {
          setIsOpen(true);
        }
        reset();
        setDatabaseValidator(false);
      }
    } catch (error) {
      console.error("Error in submitting form:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const notified = () =>
    toast.error("SORRY YOU ARE NOT AUTHORISED TO RESERVE A SEAT");

  const isValidEmail = (email) => {
    // Regular expression for email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleSwitchToggle = () => {
    setChatEnabled(!chatEnabled);
  };

  return (
    <div className="guideCont max-w-7xl mx-auto">
      {isLoading && <NetworkLoader />}
      <div className="h2Text">
        <h2>Fill the form below to reserve a seat at the event</h2>
        <div className="arrowDown">
          <IoIosArrowDown />
        </div>
      </div>
      <form onSubmit={registerForm(onSubmit)} className="max-w-4xl mx-auto">
        <div className="guideContainer">
          <div className="nameEmail">
            <div className="nameBox">
              <div className="nameIcon">
                <MdPermContactCalendar />
              </div>
              <label htmlFor="name" className="nameLabel">
                Your name:
              </label>
              <input
                {...register("name")}
                type="text"
                className="nameInputt"
                id="name"
                name="name"
              />
              <p>
                {errors.name && (
                  <span className="error-message">{errors.name.message}</span>
                )}
              </p>
            </div>
            <div className="emailBox">
              <div className="emailIcon">
                <MdAlternateEmail />
              </div>
              <label htmlFor="email" className="emailLabel">
                Email:
              </label>
              <input
                {...register("email")}
                className={`emailInputt ${!errors.email ? "error-message" : ""}`}
                type="email"
                id="email"
                name="email"
              />{" "}
              <p>
                {errors.email && (
                  <span className="error-message">{errors.email.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="nameEmail">
            <div className="phoneBox">
              <div className="pIcon">
                <IoIosCall />
              </div>
              <label htmlFor="phone" className="phoneLabe">
                Phone Number:
              </label>

              <div className="relative">
                <label htmlFor="phone-input">Phone Number</label>
                <Controller
                  name="phone"
                  control={control}
                  rules={{
                    validate: (value) => isValidPhoneNumber(value),
                  }}
                  render={({ field: { onChange, value } }) => (
                    <PhoneInput
                      value={value}
                      onChange={onChange}
                      addInternationalOption={false}
                      defaultCountry="NG"
                      id="phone"
                      className="phonePutt"
                      countries={allowedCountries}
                      placeholder="+234 123 456 7890"
                    />
                  )}
                />
                <p className="absolute -bottom-5">
                  {errors.phone && (
                    <span className="error-message">
                      {errors.phone.message}
                    </span>
                  )}
                </p>
              </div>
            </div>

            <div className="nameBox">
              <div className="nameIcon">
                <MdLocalHospital />
              </div>
              <label htmlFor="hospital" className="nameLabel">
                Hospital Name:
              </label>
              <input
                {...register("hospital")}
                type="text"
                className="nameInputt"
                id="hospital"
                name="hospital"
              />
              <p>
                {errors.hospital && (
                  <span className="error-message">
                    {errors.hospital.message}
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="nameEmail">
            <div className="emailBox">
              <div className="emailIcon">
                <TbBuildingEstate />
              </div>
              <label htmlFor="country" className="emailLabel">
                Country:
              </label>
              <select
                {...register("country")}
                name="country"
                id="country"
                className={`emailInputt`}
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  setSelectedState(""); // Reset state selection when country changes
                  setCities([]); // Reset cities when country changes
                }}
              >
                <option value="">Select Country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </select>
              <p>
                {errors.country && (
                  <span className="error-message">
                    {errors.country.message}
                  </span>
                )}
              </p>
            </div>

            <div className="emailBox">
              <div className="emailIcon">
                <TbBuildingEstate />
              </div>
              <label htmlFor="state" className="emailLabel">
                State of Operation:
              </label>
              <select
                {...register("state")}
                name="state"
                id="state"
                className={`emailInputt`}
                onChange={(e) => setSelectedState(e.target.value)}
                disabled={!selectedCountry} // Disable if no country is selected
              >
                <option value="">Select State</option>
                {selectedCountry === "Nigeria" && (
                  <option value="Federal Capital Territory">Abuja</option>
                )}
                {states
                  .filter((state) => state.state_code !== "NG-FC")
                  .map((state, index) => {
                    const stateName =
                      state.name === "Federal Capital Territory"
                        ? "Abuja"
                        : state.name;
                    return (
                      <option key={index} value={stateName}>
                        {stateName}
                      </option>
                    );
                  })}
              </select>
              <p>
                {errors.state && (
                  <span className="error-message">{errors.state.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="nameEmail">
            <div className="nameBox">
              <div className="nameIcon">
                <PiCityFill />
              </div>
              <label htmlFor="city" className="nameLabel">
                City of Operation:
              </label>
              <select
                {...register("city")}
                name="city"
                id="city"
                className={`emailInputt`}
                disabled={!selectedState}
              >
                <option value="">Select City</option>
                {cities.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              <p>
                {errors.city && (
                  <span className="error-message">{errors.city.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="nameEmail">
            <div className="input-group1">
              <label>
                <input
                  {...register("checked")}
                  type="checkbox"
                  name="checked"
                  className="checkbox"
                />{" "}
                I currently work here
              </label>
            </div>

            <div className="chatBox mt-5 md:mt-0">
              <div className="p-div">
                <div className="ph">
                  <p>
                    Would you like to have a chat <br /> with LifeBank?
                  </p>

                  <Switch
                    onChange={handleSwitchToggle}
                    checked={chatEnabled}
                    className="mt-5 ml-5 switch"
                    onColor="#008000"
                    offColor="#ccc"
                    onHandleColor="#fff"
                    offHandleColor="#fff"
                    handleDiameter={20}
                    height={28}
                    width={60}
                    checkedIcon={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          fontSize: "14px",
                          color: "white",
                        }}
                      >
                        Yes
                      </div>
                    }
                    uncheckedIcon={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          fontSize: "14px",
                        }}
                      >
                        No
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {chatEnabled && (
            <EventChatInfo
              control={control}
              register={register}
              errors={errors}
            />
          )}
          <div className="Btn mt-5">
            <button
              className="disabled:opacity-50"
              // disabled={!databaseValidator && !chatEnabled}
              type="submit"
            >
              <div className="b-Icon">
                Reserve A Seat
                <div className="ml-3">
                  <BsFillArrowRightCircleFill />
                </div>
              </div>
            </button>
            <Toaster />
          </div>
          {isOpen && (
            <GrantModal
              setIsOpen={setIsOpen}
              title="Seat Reserved Successfully!"
              message="A copy of your reservation has been sent to your provided email"
            />
          )}
        </div>
      </form>
      <Modal ref={ModalRef}>
        <div className="modalContent space-y-5 flex flex-col items-center px-5 text-center">
          <h2>SORRY YOU ARE NOT AUTHORIZED TO ACCESS THIS EVENT</h2>
          <p>This event is only for our customers</p>

          <p>Kindly fill the below form to chat with LifeBank</p>

          <button
            className="bg-blue-500 p-3 rounded-md mx-auto text-white"
            onClick={() => {
              setChatEnabled(true);
              ModalRef.current.closeModal();
            }}
          >
            Chat with LifeBank
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default EventInfo;
